import { useState, useCallback } from 'react';
import { scheduleUpdatesService } from '../services';

export const useScheduleUpdates = () => {
  const [allScheduleUpdates, setAllScheduleUpdates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchScheduleUpdates = useCallback(async (sectorId) => {
    if (!sectorId) return;

    setLoading(true);
    setError(null);

    try {
      const scheduleUpdates =
        await scheduleUpdatesService.showBySector(sectorId);
      setAllScheduleUpdates(scheduleUpdates?.updates || []);
      return scheduleUpdates?.updates || [];
    } catch (err) {
      setError(err);
      // eslint-disable-next-line no-console
      console.error('Error fetching schedule updates:', err);
      return [];
    } finally {
      setLoading(false);
    }
  }, []);

  const updateScheduleUpdates = useCallback(async (sectorId) => {
    if (!sectorId) return;

    try {
      const scheduleUpdates =
        await scheduleUpdatesService.showBySector(sectorId);
      setAllScheduleUpdates(scheduleUpdates?.updates || []);
      return scheduleUpdates?.updates || [];
    } catch (err) {
      setError(err);
      // eslint-disable-next-line no-console
      console.error('Error updating schedule updates:', err);
      return [];
    }
  }, []);

  return {
    allScheduleUpdates,
    loading,
    error,
    fetchScheduleUpdates,
    updateScheduleUpdates,
    setAllScheduleUpdates
  };
};
